module.exports = __webpack_public_path__ + "static/img/open.1601f8e9.svg";